import React, { Component, Fragment } from "react";
import NumberFormat from "react-number-format";
import { connect } from "react-redux";
import { Link, Redirect } from "react-router-dom";
import { FaInfoCircle } from "react-icons/fa";
import {
  change_Lang,
  EveryTimeTo_English,
} from "../../../actions/Helper_action";
import { Create_Sell_MainForm } from "../../../actions_agent/Invoice_action";
import Breadcrumb from "../../../components/common/breadcrumb";
import Swal from "sweetalert2";
import { Divider, Input, Popover, Select } from "antd";
import PropertyesList from "../../Propertys_Agent/PropertyesList";
export class SellSecondaryForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      lastPrice: 0,
      introduction: 0,
      firstname: "",
      secondname: "",
      duedate: "",
      lawman: "",
      fee: 0,
      reject: 0,
      save: null,
      Area: "",
      Property: "",
      NOoFProperty: "",
      phone1: 0,
      phone2: 0,
      Place_ku: "",
      pay_day: "",
      pay: 0,
      note: "",
      block: "",
      flour: "",
      metrPrice: "",
      witness1: "",
      witness2: "",
      status: "active",
      redirect: false,
      article_8: "",
      article_9: "",
      article_10: "",
      article_8_ar: "",
      article_9_ar: "",
      article_10_ar: "",
    };
  }
  New_Page = () => {
    this.setState({
      lastPrice: 0,
      introduction: 0,
      firstname: "",
      secondname: "",
      duedate: "",
      lawman: "",
      fee: 0,
      reject: 0,
      save: null,
      Area: "",
      Property: "",
      NOoFProperty: "",
      phone1: 0,
      phone2: 0,
      Place_ku: "",
      pay_day: "",
      pay: 0,
      note: "",
      block: "",
      flour: "",
      metrPrice: "",
      witness1: "",
      witness2: "",
      status: "active",
      redirect: false,
      article_8: "",
      article_9: "",
      article_10: "",
      article_8_ar: "",
      article_9_ar: "",
      article_10_ar: "",
    });
  };

  onCreating_SellContract = () => {
    var curr = new Date();
    curr.setDate(curr.getDate());
    let today = curr.toISOString().substr(0, 10);
    const data = {
      firstname: this.state.firstname,
      secondname: this.state.secondname,
      introduction:
        this.state.introduction !== ""
          ? parseFloat(this.state.introduction.toString().replace(/,/g, ""))
          : 0,
      lastPrice:
        this.state.lastPrice !== ""
          ? parseFloat(this.state.lastPrice.toString().replace(/,/g, ""))
          : 0,
      duedate: this.state.duedate !== "" ? this.state.duedate : today,
      lawman: this.state.lawman,
      fee:
        this.state.fee !== ""
          ? parseFloat(this.state.fee.toString().replace(/,/g, ""))
          : 0,
      reject:
        this.state.reject !== ""
          ? parseFloat(this.state.reject.toString().replace(/,/g, ""))
          : 0,
      pay:
        this.state.pay !== ""
          ? parseFloat(this.state.pay.toString().replace(/,/g, ""))
          : 0,
      Area: this.state.Area,
      Property: this.state.Property,
      NOoFProperty: this.state.NOoFProperty,
      Place_ku: this.state.Place_ku,
      phone1: this.state.phone1 !== "" ? this.state.phone1 : 0,
      phone2: this.state.phone2 !== "" ? this.state.phone2 : 0,
      pay_day: this.state.pay_day !== "" ? this.state.pay_day : today,
      note: this.state.note,
      block: this.state.block,
      flour: this.state.flour,
      metrPrice: this.state.metrPrice,
      witness1: this.state.witness1,
      witness2: this.state.witness2,
      status: this.state.status,
      article_8: this.state.article_8,
      article_9: this.state.article_9,
      article_10: this.state.article_10,
      article_8_ar: this.state.article_8_ar,
      article_9_ar: this.state.article_9_ar,
      article_10_ar: this.state.article_10_ar,
    };
    if (
      this.state.firstname === "" ||
      this.state.secondname === "" ||
      this.state.lastPrice === "" ||
      this.state.lastPrice === 0 ||
      this.state.Property.toString().length === 0
    ) {
      Swal.fire({
        title: "OPS",
        text: this.props.change_Lang("Please Check Inputs"),
        icon: "error",
        html: `<b class="fk">${this.props.change_Lang(
          "Please Check Inputs"
        )}</b>`,
        confirmButtonText: this.props.change_Lang("Ok"),
        buttonsStyling: { fontFamily: "fk" },
        timer: 1300,
      });
    } else {
      Swal.fire({
        title: "Good job!",
        html: `<b class="fk">${this.props.change_Lang(
          "You successfully tainted your work"
        )}</b>`,
        icon: "success",
        confirmButtonText: this.props.change_Lang("success"),
        buttonsStyling: { fontFamily: "fk" },
        timer: 1000,
      });
      this.props.Create_Sell_MainForm(data);
      this.setState({
        save: true,
        redirect: true,
      });
    }
  };
  OnChangeHandler = (e) => {
    this.setState(
      {
        [e.target.name]: e.target.value,
      },
      () => {
        this.Kamkrdnawa();
      }
    );
  };
  handleChange_Property = (value) => {
    this.setState({ Property: value });
  };
  Kamkrdnawa = () => {
    let x = Number(
      parseFloat(this.state.lastPrice.toString().replace(/,/g, ""))
    );
    let y = Number(
      parseFloat(this.state.introduction.toString().replace(/,/g, ""))
    );
    let z = Number(parseFloat(this.state.pay.toString().replace(/,/g, "")));
    z =
      parseFloat(x.toString().replace(/,/g, "")) -
      parseFloat(y.toString().replace(/,/g, ""));
    this.setState({ pay: z });
  };
  handleKeyDown = (event) => {
    if (event.key === "-" || event.key === "e" || event.key === "ArrowDown") {
      event.preventDefault();
    }
  };
  handleChange_Status = (value) => {
    this.setState({ status: value });
  };
  render() {
    const { change_Lang, lang, user } = this.props;
    const { OnChangeHandler, New_Page, handleKeyDown, handleChange_Status } =
      this;
    const {
      lastPrice,
      introduction,
      firstname,
      secondname,
      duedate,
      lawman,
      fee,
      reject,
      Area,
      Property,
      NOoFProperty,
      phone1,
      phone2,
      Place_ku,
      pay,
      note,
      block,
      flour,
      metrPrice,
      status,
      pay_day,
      redirect,
      article_9,
      article_10,
      article_8,
      article_10_ar,
      article_8_ar,
      article_9_ar,
    } = this.state;
    var curr = new Date();
    curr.setDate(curr.getDate());
    let today = curr.toISOString().substr(0, 10);
    const { Option } = Select;
    if (redirect) {
      if (status !== "Rejected") {
        return <Redirect to="/List_Sell_Invoices" />;
      } else {
        return <Redirect to="/List_Sell_Invoices_fast" />;
      }
    } else {
      return (
        <Fragment>
          <Breadcrumb
            title={change_Lang("Sell_Contracts")}
            parent={change_Lang("s_dashboard")}
          />
          <div
            className={`${
              lang === "en" ? "container-fluid" : "container-fluid fk"
            }`}
          >
            <div
              className="card product-page-main card-body"
              style={{ background: "#e3e9f2 " }}
            >
              <div className="row">
                <div
                  className="col-sm-3 d-flex justify-content-center"
                  style={{
                    background: "white",
                    borderRadius: "10px",
                  }}
                >
                  <Link to="/Secondary_Sell_Form">
                    <label
                      style={{
                        fontWeight: "bolder",
                        fontSize: "16px",
                        color: "#4064d7",
                        marginTop: "5px",
                        cursor: "pointer",
                      }}
                      className=" d-flex justify-content-start "
                    >
                      {change_Lang("Secondary Form")}
                    </label>
                  </Link>
                  &nbsp;&nbsp;
                  <Link to="/Main_Sell_Form">
                    <label
                      style={{
                        fontSize: "16px",
                        color: "#052f43",
                        marginTop: "5px",

                        cursor: "pointer",
                      }}
                      className=" d-flex justify-content-end"
                    >
                      {change_Lang("Main Form")}
                    </label>
                  </Link>
                </div>
              </div>
              <div className="card-body">
                <div
                  className="row d-flex justify-content-center"
                  style={{
                    background: "white",
                    borderRadius: "10px",
                  }}
                >
                  <div className="col-sm-12 d-flex justify-content-center">
                    <label
                      style={{
                        fontWeight: "bolder",
                        fontSize: "18px",
                        color: "#052f43",
                        margin: "5px 0px 3px 0px",
                      }}
                    >
                      {change_Lang("Sell_Contracts")}
                    </label>
                  </div>
                </div>
                <br />
                <div className="row mb-4 ">
                  <div className="col-sm-6  ">
                    <div className="product-price digits mt-2 d-flex justify-content-start form-group row">
                      <div className="col-sm-4">
                        <label
                          style={{
                            fontSize: "16px",
                            color: "#052f43",
                            fontWeight: "bold",
                          }}
                          className={`d-flex justify-content-start ${
                            lang === "en"
                              ? "col-form-label"
                              : "col-form-label fk"
                          }`}
                        >
                          {change_Lang("First Party")}:
                        </label>
                      </div>
                      <div className="col-sm-8">
                        <Input
                          type="text"
                          value={firstname}
                          onChange={OnChangeHandler}
                          name="firstname"
                          autoComplete="off"
                          className={`${
                            lang === "en"
                              ? "form-control text-center"
                              : "form-control text-center fk"
                          }`}
                          style={{
                            fontSize: "16px",

                            borderBottomColor: "#3889c1",
                          }}
                          addonBefore={
                            <>
                              <Popover
                                content={
                                  <div className="text-center">
                                    <span
                                      className="fk"
                                      style={{ fontSize: "14px" }}
                                    >
                                      {
                                        "ناوی  خاوەن موڵك(فرۆشیار) داخل بکە بەم شێوەیە "
                                      }
                                    </span>
                                    <br />
                                    <span className="text-center">
                                      نمونە : محمد عبداللە عمر
                                    </span>
                                  </div>
                                }
                              >
                                <FaInfoCircle
                                  style={{
                                    justifyContent: "center",
                                    alignItems: "center",
                                    display: "flex",
                                    color: "#000",
                                    fontWeight: "bolder",
                                  }}
                                  size={15}
                                />
                              </Popover>
                            </>
                          }
                        />
                      </div>
                    </div>
                    <div className="product-price digits mt-2 d-flex justify-content-start form-group row">
                      <div className="col-sm-4">
                        <label
                          style={{
                            fontSize: "16px",
                            color: "#052f43",
                            fontWeight: "bold",
                          }}
                          className={`d-flex justify-content-start ${
                            lang === "en"
                              ? "col-form-label"
                              : "col-form-label fk"
                          }`}
                        >
                          {change_Lang("phone_number")}:
                        </label>
                      </div>
                      <div className="col-sm-8">
                        <Input
                          type="number"
                          value={phone1 === 0 ? "" : phone1}
                          onKeyDown={handleKeyDown}
                          onChange={OnChangeHandler}
                          name="phone1"
                          min={1}
                          step={1}
                          autoComplete="off"
                          className={`${
                            lang === "en"
                              ? "form-control text-center"
                              : "form-control text-center fk"
                          }`}
                          style={{
                            fontSize: "16px",

                            borderBottomColor: "#3889c1",
                          }}
                          addonBefore={
                            <>
                              <Popover
                                content={
                                  <div className="text-center">
                                    <span
                                      className="fk"
                                      style={{ fontSize: "14px" }}
                                    >
                                      {
                                        "ژمارەی مۆبایلی خاوەن موڵك(فرۆشیار) داخل بکە بەم شێوەیە "
                                      }
                                    </span>
                                    <br />
                                    <span className="text-center">
                                      نمونە : 07501002020
                                    </span>
                                  </div>
                                }
                              >
                                <FaInfoCircle
                                  style={{
                                    justifyContent: "center",
                                    alignItems: "center",
                                    display: "flex",
                                    color: "#000",
                                    fontWeight: "bolder",
                                  }}
                                  size={15}
                                />
                              </Popover>
                            </>
                          }
                        />
                      </div>
                    </div>
                    {/* <div className="product-price digits mt-2 d-flex justify-content-start form-group row">
                    <div className="col-sm-4">
                      <label
                        style={{
                          fontSize: "16px",
                          color: "#052f43",
                          fontWeight: "bold",
                        }}
                        className={`d-flex justify-content-start ${
                          lang === "en" ? "col-form-label" : "col-form-label fk"
                        }`}
                      >
                        {change_Lang("Witness")}:
                      </label>
                    </div>
                    <div className="col-sm-8">
                      <Input
                        type="text"
                        value={witness1}
                        onChange={OnChangeHandler}
                        name="witness1"
                        autoComplete="off"
                        className={`${
                          lang === "en"
                            ? "form-control text-center"
                            : "form-control text-center fk"
                        }`}
                        style={{
                          fontSize: "16px",

                          borderBottomColor: "#3889c1",
                        }}
                        addonBefore={
                          <>
                            <Popover
                              content={
                                <div className="text-center">
                                  <span
                                    className="fk"
                                    style={{ fontSize: "14px" }}
                                  >
                                    {"ناوی  شاهێد داخل بکە بەم شێوەیە "}
                                  </span>
                                  <br />
                                  <span className="text-center">
                                    نمونە : محمد عبداللە عمر
                                  </span>
                                </div>
                              }
                            >
                              <span className=" py-0 px-0">
                                <i className="fas fa-info-circle"></i>
                              </span>
                            </Popover>
                          </>
                        }
                      />
                    </div>
                  </div> */}
                    <div className="product-price digits mt-2 form-group row ">
                      <div className="col-sm-4 ">
                        <label
                          style={{
                            fontSize: "16px",
                            color: "#052f43",
                            fontWeight: "bold",
                          }}
                          className={`d-flex justify-content-start ${
                            lang === "en"
                              ? "col-form-label"
                              : "col-form-label fk"
                          }`}
                        >
                          {change_Lang("Type of property")}:
                        </label>
                      </div>
                      <div className="col-sm-8 ">
                        <PropertyesList
                          onChangeProperty={this.handleChange_Property}
                          valueOption={Property}
                          size="large"
                        />
                      </div>
                    </div>
                    {Property !== "Apartment" ? (
                      ""
                    ) : (
                      <div className="product-price digits mt-2 form-group row">
                        <div className="col-sm-4">
                          <label
                            style={{
                              fontSize: "16px",
                              color: "#052f43",
                              fontWeight: "bold",
                            }}
                            className={`d-flex justify-content-start ${
                              lang === "en"
                                ? "col-form-label"
                                : "col-form-label fk"
                            }`}
                          >
                            {change_Lang("block")}:
                          </label>
                        </div>
                        <div
                          className={`${
                            lang === "en" ? "col-sm-8" : "col-sm-8 fk"
                          }`}
                        >
                          <Input
                            className={`${
                              lang === "en"
                                ? "form-control text-center"
                                : "form-control text-center fk"
                            }`}
                            onChange={OnChangeHandler}
                            type="text"
                            value={block}
                            name="block"
                            style={{
                              fontSize: "16px",

                              borderBottomColor: "#3889c1",
                            }}
                            autoComplete="off"
                            addonBefore={
                              <>
                                <Popover
                                  content={
                                    <div className="text-center">
                                      <span
                                        className="fk"
                                        style={{ fontSize: "14px" }}
                                      >
                                        {
                                          "باڵەخەنەی شووقەکە داخڵ بکە بەم شێوەیە"
                                        }
                                      </span>
                                      <br />
                                      <span className="text-center">
                                        نمونە : A
                                      </span>
                                    </div>
                                  }
                                >
                                  <span className=" py-0 px-0">
                                    <i className="fas fa-info-circle"></i>
                                  </span>
                                </Popover>
                              </>
                            }
                          />
                        </div>
                      </div>
                    )}
                    {Property !== "Apartment" ? (
                      ""
                    ) : (
                      <div className="product-price digits mt-2 form-group row">
                        <div className="col-sm-4">
                          <label
                            style={{
                              fontSize: "16px",
                              color: "#052f43",
                              fontWeight: "bold",
                            }}
                            className={`d-flex justify-content-start ${
                              lang === "en"
                                ? "col-form-label"
                                : "col-form-label fk"
                            }`}
                          >
                            {change_Lang("MetrPrice")}:
                          </label>
                        </div>
                        <div
                          className={`${
                            lang === "en" ? "col-sm-8" : "col-sm-8 fk"
                          }`}
                        >
                          <Input
                            className={`${
                              lang === "en"
                                ? "form-control text-center"
                                : "form-control text-center fk"
                            }`}
                            onChange={OnChangeHandler}
                            type="number"
                            value={metrPrice}
                            name="metrPrice"
                            min={1}
                            step={1}
                            onKeyDown={handleKeyDown}
                            style={{
                              fontSize: "16px",

                              borderBottomColor: "#3889c1",
                            }}
                            autoComplete="off"
                            addonBefore={
                              <>
                                <Popover
                                  content={
                                    <div className="text-center">
                                      <span
                                        className="fk"
                                        style={{ fontSize: "14px" }}
                                      >
                                        {
                                          "نرخی مەتری شووقەکە داخڵ بکە بەم شێوەیە تەنها ژمارە داخڵ بکە"
                                        }
                                      </span>
                                      <br />
                                      <span className="text-center">
                                        نمونە : 500
                                      </span>
                                    </div>
                                  }
                                >
                                  <span className=" py-0 px-0">
                                    <i className="fas fa-info-circle"></i>
                                  </span>
                                </Popover>
                              </>
                            }
                          />
                        </div>
                      </div>
                    )}
                    <div className="product-price digits mt-2 form-group row">
                      <div className="col-sm-4">
                        <label
                          style={{
                            fontSize: "16px",
                            color: "#052f43",
                            fontWeight: "bold",
                          }}
                          className={`d-flex justify-content-start ${
                            lang === "en"
                              ? "col-form-label"
                              : "col-form-label fk"
                          }`}
                        >
                          {change_Lang("Number of property")}:
                        </label>
                      </div>
                      <div
                        className={`${
                          lang === "en" ? "col-sm-8" : "col-sm-8 fk"
                        }`}
                      >
                        <Input
                          className={`${
                            lang === "en"
                              ? "form-control text-center"
                              : "form-control text-center fk"
                          }`}
                          onChange={OnChangeHandler}
                          type="text"
                          style={{
                            fontSize: "16px",

                            borderBottomColor: "#3889c1",
                          }}
                          value={NOoFProperty}
                          name="NOoFProperty"
                          autoComplete="off"
                          addonBefore={
                            <>
                              <Popover
                                content={
                                  <div className="text-center">
                                    <span
                                      className="fk"
                                      style={{ fontSize: "14px" }}
                                    >
                                      {"ژمارەی موڵکەکە داخل بکە بەم شێوەیە "}
                                    </span>
                                    <br />
                                    <span className="text-center">
                                      نمونە : 12/15/250 یان 1
                                    </span>
                                  </div>
                                }
                              >
                                <FaInfoCircle
                                  style={{
                                    justifyContent: "center",
                                    alignItems: "center",
                                    display: "flex",
                                    color: "#000",
                                    fontWeight: "bolder",
                                  }}
                                  size={15}
                                />
                              </Popover>
                            </>
                          }
                        />
                      </div>
                    </div>
                    <div className="product-price digits mt-2 form-group row">
                      <div className="col-sm-4">
                        <label
                          style={{
                            fontSize: "16px",
                            color: "#052f43",
                            fontWeight: "bold",
                          }}
                          className={`d-flex justify-content-start ${
                            lang === "en"
                              ? "col-form-label"
                              : "col-form-label fk"
                          }`}
                        >
                          {change_Lang("pr_price")}:
                        </label>
                      </div>
                      <div
                        className={`${
                          lang === "en" ? "col-sm-8" : "col-sm-8 fk"
                        }`}
                      >
                        <NumberFormat
                          style={{
                            fontSize: "16px",

                            borderBottomColor: "#3889c1",
                          }}
                          displayType="input"
                          thousandSeparator={true}
                          name="lastPrice"
                          onChange={OnChangeHandler}
                          value={lastPrice === 0 ? "" : lastPrice}
                          required
                          min={1}
                          step={1}
                          onKeyDown={handleKeyDown}
                          className={`${
                            lang === "en"
                              ? "form-control text-center"
                              : "form-control text-center fk"
                          }`}
                          autoComplete="off"
                        />
                      </div>
                    </div>
                    {/* <div className="product-price digits mt-2 form-group row">
                      <div className="col-sm-4">
                        <label
                          style={{
                            fontSize: "16px",
                            color: "#052f43",
                            fontWeight: "bold",
                          }}
                          className={`d-flex justify-content-start ${
                            lang === "en"
                              ? "col-form-label"
                              : "col-form-label fk"
                          }`}
                        >
                          {change_Lang("recive_money")}:
                        </label>
                      </div>
                      <div
                        className={`${
                          lang === "en" ? "col-sm-8" : "col-sm-8 fk"
                        }`}
                      >
                        <NumberFormat
                          style={{
                            fontSize: "16px",

                            borderBottomColor: "#3889c1",
                          }}
                          displayType="input"
                          thousandSeparator={true}
                          name="pay"
                          onChange={OnChangeHandler}
                          value={pay === 0 ? "" : pay}
                          min={1}
                          step={1}
                          onKeyDown={handleKeyDown}
                          required
                          className={`${
                            lang === "en"
                              ? "form-control text-center"
                              : "form-control text-center fk"
                          }`}
                          autoComplete="off"
                        />
                      </div>
                    </div> */}
                    <div className="product-price digits mt-2 form-group row">
                      <div className="col-sm-4">
                        <label
                          style={{
                            fontSize: "14px",
                            color: "#052f43",
                            fontWeight: "bold",
                          }}
                          className={`d-flex justify-content-start ${
                            lang === "en"
                              ? "col-form-label"
                              : "col-form-label fk"
                          }`}
                        >
                          {change_Lang("Amount of dissuade")}:
                        </label>
                      </div>
                      <div
                        className={`${
                          lang === "en" ? "col-sm-8" : "col-sm-8 fk"
                        }`}
                      >
                        <Input
                          className={`${
                            lang === "en"
                              ? "form-control text-center"
                              : "form-control text-center fk"
                          }`}
                          type="number"
                          value={fee === 0 ? "" : fee}
                          onChange={OnChangeHandler}
                          name="fee"
                          min={1}
                          step={1}
                          onKeyDown={handleKeyDown}
                          autoComplete="off"
                          style={{
                            fontSize: "16px",
                          }}
                          addonBefore={
                            <>
                              <Popover
                                content={
                                  <div className="text-center">
                                    <span
                                      className="fk"
                                      style={{ fontSize: "14px" }}
                                    >
                                      {
                                        "ئەگەر هاتوو هەر لایەنێک بەهەر هۆیەک پاشگەز بێتەوە لەم گرێبەستە دەبێت پابەند بێت بە پێدانی_____ تەنها ژمارە داخڵ بکە"
                                      }
                                    </span>
                                    <br />
                                    <span className="text-center">
                                      نمونە : 1000
                                    </span>
                                  </div>
                                }
                              >
                                <FaInfoCircle
                                  style={{
                                    justifyContent: "center",
                                    alignItems: "center",
                                    display: "flex",
                                    color: "#000",
                                    fontWeight: "bolder",
                                  }}
                                  size={15}
                                />
                              </Popover>
                            </>
                          }
                        />
                      </div>
                    </div>
                    {/* p_day */}
                    {/* <div className="product-price digits mt-2 d-flex justify-content-start form-group row">
                      <div className="col-sm-4">
                        <label
                          style={{
                            fontSize: "16px",
                            color: "#052f43",
                            fontWeight: "bold",
                          }}
                          className={`d-flex justify-content-start ${
                            lang === "en"
                              ? "col-form-label"
                              : "col-form-label fk"
                          }`}
                        >
                          {change_Lang("payment date left")}:
                        </label>
                      </div>
                      <div
                        className={`${
                          lang === "en" ? "col-sm-8" : "col-sm-8 fk"
                        }`}
                      >
                        <Input
                          className="form-control"
                          onChange={OnChangeHandler}
                          type="date"
                          value={pay_day !== "" ? pay_day : today}
                          name="pay_day"
                          style={{
                            fontSize: "16px",

                            borderBottomColor: "#3889c1",
                          }}
                          addonBefore={
                            <>
                              <Popover
                                content={
                                  <div className="text-center">
                                    <span
                                      className="fk"
                                      style={{ fontSize: "14px" }}
                                    >
                                      {
                                        "ڕیکەوتی پارەدانی پارەی ماوە بنووسە کە لەسەر لایەنی دووەمە پارەکە بداتن."
                                      }
                                    </span>
                                    <br />
                                    <span className="text-center"></span>
                                  </div>
                                }
                              >
                                <FaInfoCircle
                                  style={{
                                    justifyContent: "center",
                                    alignItems: "center",
                                    display: "flex",
                                    color: "#000",
                                    fontWeight: "bolder",
                                  }}
                                  size={15}
                                />
                              </Popover>
                            </>
                          }
                        />
                      </div>
                    </div> */}
                    <div className="product-price digits mt-2 d-flex justify-content-start form-group row">
                      <div className="col-sm-4">
                        <label
                          style={{
                            fontSize: "16px",
                            color: "#052f43",
                            fontWeight: "bold",
                          }}
                          className={`d-flex justify-content-start ${
                            lang === "en"
                              ? "col-form-label"
                              : "col-form-label fk"
                          }`}
                        >
                          {change_Lang("note")}:
                        </label>
                      </div>
                      <div
                        className={`${
                          lang === "en" ? "col-sm-8" : "col-sm-8 fk"
                        }`}
                      >
                        <Input
                          className="form-control"
                          onChange={OnChangeHandler}
                          type="text"
                          value={note}
                          name="note"
                          style={{
                            fontSize: "16px",

                            borderBottomColor: "#3889c1",
                          }}
                          addonBefore={
                            <>
                              <Popover
                                content={
                                  <div className="text-center">
                                    <span
                                      className="fk"
                                      style={{ fontSize: "14px" }}
                                    >
                                      {
                                        "هەر تێبینیەکت هەبوو لێرە بینووسە لە خوارەوەی گریبەستەکەت دەردەکەوێ"
                                      }
                                    </span>
                                    <br />
                                    <span className="text-center"></span>
                                  </div>
                                }
                              >
                                <FaInfoCircle
                                  style={{
                                    justifyContent: "center",
                                    alignItems: "center",
                                    display: "flex",
                                    color: "#000",
                                    fontWeight: "bolder",
                                  }}
                                  size={15}
                                />
                              </Popover>
                            </>
                          }
                        />
                      </div>
                    </div>
                    <br />
                  </div>
                  <div className="col-sm-6 mt-2">
                    <div className="product-price digits form-group row">
                      <div className="col-sm-4">
                        <label
                          style={{
                            fontSize: "14px",
                            color: "#052f43",
                            fontWeight: "bold",
                          }}
                          className={`d-flex justify-content-start mt-1 ${
                            lang === "en"
                              ? "col-form-label"
                              : "col-form-label fk"
                          }`}
                        >
                          {change_Lang("Second Party (Buyer)")}:
                        </label>
                      </div>
                      <div
                        className="col-sm-8"
                        style={{
                          fontSize: "16px",

                          borderBottomColor: "#3889c1",
                        }}
                      >
                        <Input
                          className={`${
                            lang === "en"
                              ? "form-control text-center"
                              : "form-control text-center fk"
                          }`}
                          onChange={OnChangeHandler}
                          type="text"
                          value={secondname}
                          name="secondname"
                          style={{
                            fontSize: "16px",

                            borderBottomColor: "#3889c1",
                          }}
                          addonBefore={
                            <>
                              <Popover
                                content={
                                  <div className="text-center">
                                    <span
                                      className="fk"
                                      style={{ fontSize: "14px" }}
                                    >
                                      {
                                        "ناوی لایەنی دووەم (کڕیار) داخل بکە بەم شێوەیە "
                                      }
                                    </span>
                                    <br />
                                    <span className="text-center">
                                      محمد عبداللە عمر
                                    </span>
                                  </div>
                                }
                              >
                                <FaInfoCircle
                                  style={{
                                    justifyContent: "center",
                                    alignItems: "center",
                                    display: "flex",
                                    color: "#000",
                                    fontWeight: "bolder",
                                  }}
                                  size={15}
                                />
                              </Popover>
                            </>
                          }
                        />
                      </div>
                    </div>

                    <div className="product-price digits form-group row">
                      <div className="col-sm-4 mt-2">
                        <label
                          style={{
                            fontSize: "16px",
                            color: "#052f43",
                            fontWeight: "bold",
                          }}
                          className={`d-flex justify-content-start${
                            lang === "en"
                              ? "col-form-label"
                              : "col-form-label fk"
                          }`}
                        >
                          {change_Lang("phone_number")}:
                        </label>
                      </div>
                      <div
                        className="col-sm-8"
                        style={{
                          fontSize: "16px",

                          borderBottomColor: "#3889c1",
                        }}
                      >
                        <Input
                          className={`${
                            lang === "en"
                              ? "form-control text-center"
                              : "form-control text-center fk"
                          }`}
                          onChange={OnChangeHandler}
                          type="number"
                          value={phone2 === 0 ? "" : phone2}
                          onKeyDown={handleKeyDown}
                          name="phone2"
                          min={1}
                          step={1}
                          style={{
                            fontSize: "16px",

                            borderBottomColor: "#3889c1",
                          }}
                          addonBefore={
                            <>
                              <Popover
                                content={
                                  <div className="text-center">
                                    <span
                                      className="fk"
                                      style={{ fontSize: "14px" }}
                                    >
                                      {
                                        "ژمارەی مۆبایلی لایەنی دووەم (کڕیار) داخل بکە بەم شێوەیە "
                                      }
                                    </span>
                                    <br />
                                    <span className="text-center">
                                      07501002020
                                    </span>
                                  </div>
                                }
                              >
                                <FaInfoCircle
                                  style={{
                                    justifyContent: "center",
                                    alignItems: "center",
                                    display: "flex",
                                    color: "#000",
                                    fontWeight: "bolder",
                                  }}
                                  size={15}
                                />
                              </Popover>
                            </>
                          }
                        />
                      </div>
                    </div>
                    {/* <div className="product-price digits form-group row">
                    <div className="col-sm-4 mt-2">
                      <label
                        style={{
                          fontSize: "16px",
                          color: "#052f43",
                          fontWeight: "bold",
                        }}
                        className={`d-flex justify-content-start${
                          lang === "en" ? "col-form-label" : "col-form-label fk"
                        }`}
                      >
                        {change_Lang("Witness")}:
                      </label>
                    </div>
                    <div
                      className="col-sm-8"
                      style={{
                        fontSize: "16px",

                        borderBottomColor: "#3889c1",
                      }}
                    >
                      <Input
                        className={`${
                          lang === "en"
                            ? "form-control text-center"
                            : "form-control text-center fk"
                        }`}
                        onChange={OnChangeHandler}
                        type="text"
                        value={witness2}
                        name="witness2"
                        style={{
                          fontSize: "16px",

                          borderBottomColor: "#3889c1",
                        }}
                        addonBefore={
                          <>
                            <Popover
                              content={
                                <div className="text-center">
                                  <span
                                    className="fk"
                                    style={{ fontSize: "14px" }}
                                  >
                                    {"ناوی شاهێد داخل بکە بەم شێوەیە "}
                                  </span>
                                  <br />
                                  <span className="text-center">
                                    محمد عبداللە عمر
                                  </span>
                                </div>
                              }
                            >
                              <span className=" py-0 px-0">
                                <i className="fas fa-info-circle"></i>
                              </span>
                            </Popover>
                          </>
                        }
                      />
                    </div>
                  </div> */}
                    <div className="product-price digits form-group row">
                      <div className="col-sm-4">
                        <label
                          style={{
                            fontSize: "16px",
                            color: "#052f43",
                            fontWeight: "bold",
                          }}
                          className={`d-flex justify-content-start ${
                            lang === "en"
                              ? "col-form-label"
                              : "col-form-label fk"
                          }`}
                        >
                          {change_Lang("Area")}:
                        </label>
                      </div>
                      <div className="col-sm-8">
                        <Input
                          className={`${
                            lang === "en"
                              ? "form-control text-center"
                              : "form-control text-center fk"
                          }`}
                          onChange={OnChangeHandler}
                          type="number"
                          value={Area}
                          name="Area"
                          min={1}
                          step={1}
                          onKeyDown={handleKeyDown}
                          style={{
                            fontSize: "16px",

                            borderBottomColor: "#3889c1",
                          }}
                          autoComplete="off"
                          addonBefore={
                            <>
                              <Popover
                                content={
                                  <div className="text-center">
                                    <span
                                      className="fk"
                                      style={{ fontSize: "14px" }}
                                    >
                                      {
                                        "ڕووبەری موڵکەکە داخل بکە بەم شێوەیە ئاگەدار بە تەنها ژمارە داخڵ بکە"
                                      }
                                    </span>
                                    <br />
                                    <span className="text-center">
                                      نمونە : 200
                                    </span>
                                  </div>
                                }
                              >
                                <FaInfoCircle
                                  style={{
                                    justifyContent: "center",
                                    alignItems: "center",
                                    display: "flex",
                                    color: "#000",
                                    fontWeight: "bolder",
                                  }}
                                  size={15}
                                />
                              </Popover>
                            </>
                          }
                        />
                      </div>
                    </div>
                    {Property !== "Apartment" ? (
                      ""
                    ) : (
                      <div className="product-price digits mt-2 form-group row">
                        <div className="col-sm-4">
                          <label
                            style={{
                              fontSize: "16px",
                              color: "#052f43",
                              fontWeight: "bold",
                            }}
                            className={`d-flex justify-content-start ${
                              lang === "en"
                                ? "col-form-label"
                                : "col-form-label fk"
                            }`}
                          >
                            {change_Lang("flour")}:
                          </label>
                        </div>
                        <div
                          className={`${
                            lang === "en" ? "col-sm-8" : "col-sm-8 fk"
                          }`}
                        >
                          <Input
                            className={`${
                              lang === "en"
                                ? "form-control text-center"
                                : "form-control text-center fk"
                            }`}
                            onChange={OnChangeHandler}
                            type="number"
                            value={flour}
                            name="flour"
                            min={1}
                            step={1}
                            onKeyDown={handleKeyDown}
                            style={{
                              fontSize: "16px",

                              borderBottomColor: "#3889c1",
                            }}
                            autoComplete="off"
                            addonBefore={
                              <>
                                <Popover
                                  content={
                                    <div className="text-center">
                                      <span
                                        className="fk"
                                        style={{ fontSize: "14px" }}
                                      >
                                        {"قاتی شوقەکە داخڵ بکە "}
                                      </span>
                                      <br />
                                      <span className="text-center">
                                        نمونە : 12
                                      </span>
                                    </div>
                                  }
                                >
                                  <span className=" py-0 px-0">
                                    <i className="fas fa-info-circle"></i>
                                  </span>
                                </Popover>
                              </>
                            }
                          />
                        </div>
                      </div>
                    )}
                    <div className="product-price digits mt-2 d-flex justify-content-start form-group row">
                      <div className="col-sm-4">
                        <label
                          style={{
                            fontSize: "16px",
                            color: "#052f43",
                            fontWeight: "bold",
                          }}
                          className={`d-flex justify-content-start ${
                            lang === "en"
                              ? "col-form-label"
                              : "col-form-label fk"
                          }`}
                        >
                          {change_Lang("profile_location")}:
                        </label>
                      </div>
                      <div className="col-sm-8 ">
                        <Input
                          className={`${
                            lang === "en"
                              ? "form-control text-center"
                              : "form-control text-center fk"
                          }`}
                          style={{
                            color: "black",
                          }}
                          value={Place_ku}
                          onChange={OnChangeHandler}
                          name="Place_ku"
                          type="text"
                          autoComplete="off"
                          addonBefore={
                            <>
                              <Popover
                                content={
                                  <div className="text-center">
                                    <span
                                      className="fk"
                                      style={{ fontSize: "14px" }}
                                    >
                                      {"شوێنی موڵکەکە داخل بکە بەم شێوەیە "}
                                    </span>
                                    <br />
                                    <span className="text-center">
                                      نمونە : ستار تاوەر
                                    </span>
                                  </div>
                                }
                              >
                                <FaInfoCircle
                                  style={{
                                    justifyContent: "center",
                                    alignItems: "center",
                                    display: "flex",
                                    color: "#000",
                                    fontWeight: "bolder",
                                  }}
                                  size={15}
                                />
                              </Popover>
                            </>
                          }
                        />
                      </div>
                    </div>
                    {/* <div className="product-price digits mt-2 form-group row">
                      <div className="col-sm-4">
                        <label
                          style={{
                            fontSize: "16px",
                            color: "#052f43",
                            fontWeight: "bold",
                          }}
                          className={`d-flex justify-content-start ${
                            lang === "en"
                              ? "col-form-label"
                              : "col-form-label fk"
                          }`}
                        >
                          {change_Lang("amount of money in advance")}:
                        </label>
                      </div>
                      <div
                        className={`${
                          lang === "en" ? "col-sm-8" : "col-sm-8 fk"
                        }`}
                      >
                        <NumberFormat
                          style={{
                            fontSize: "16px",

                            borderBottomColor: "#3889c1",
                          }}
                          displayType="input"
                          thousandSeparator={true}
                          name="introduction"
                          onChange={OnChangeHandler}
                          value={introduction === 0 ? "" : introduction}
                          min={1}
                          step={1}
                          onKeyDown={handleKeyDown}
                          required
                          className={`${
                            lang === "en"
                              ? "form-control text-center"
                              : "form-control text-center fk"
                          }`}
                          autoComplete="off"
                        />
                      </div>
                    </div> */}
                    <div className="product-price digits mt-2 d-flex justify-content-start form-group row">
                      <div className="col-sm-4">
                        <label
                          style={{
                            fontSize: "14px",
                            color: "#052f43",
                            fontWeight: "bold",
                          }}
                          className={`d-flex justify-content-start ${
                            lang === "en"
                              ? "col-form-label"
                              : "col-form-label fk"
                          }`}
                        >
                          {change_Lang("Amount of punishment")}:
                        </label>
                      </div>
                      <div className="col-sm-8 ">
                        <Input
                          className={`${
                            lang === "en"
                              ? "form-control text-center"
                              : "form-control text-center fk"
                          }`}
                          style={{
                            color: "black",
                          }}
                          name="reject"
                          onChange={OnChangeHandler}
                          value={reject === 0 ? "" : reject}
                          type="number"
                          min={1}
                          step={1}
                          onKeyDown={handleKeyDown}
                          autoComplete="off"
                          addonBefore={
                            <>
                              <Popover
                                content={
                                  <div className="text-center">
                                    <span
                                      className="fk"
                                      style={{ fontSize: "14px" }}
                                    >
                                      ئەگەر هاتوو لایەنی یەکەم لە ڕێکەوتی دیاری
                                      کراودا ئەم موڵکەی ڕادەستی لایەنی دووەم
                                      نەکرد ئەوە دەبێت پابەند بێت بە پێدانی
                                      بڕی______
                                      <br />
                                      وەکوو پێبژاردن (غرامە) بۆ هەر رۆژێک .
                                    </span>
                                    <br />
                                    <span className="text-center">
                                      نمونە : 500
                                    </span>
                                  </div>
                                }
                              >
                                <FaInfoCircle
                                  style={{
                                    justifyContent: "center",
                                    alignItems: "center",
                                    display: "flex",
                                    color: "#000",
                                    fontWeight: "bolder",
                                  }}
                                  size={15}
                                />
                              </Popover>
                            </>
                          }
                        />
                      </div>
                    </div>
                    <div className="product-price digits mt-2 d-flex justify-content-start form-group row">
                      <div className="col-sm-4">
                        <label
                          style={{
                            fontSize: "16px",
                            color: "#052f43",
                            fontWeight: "bold",
                          }}
                          className={`d-flex justify-content-start ${
                            lang === "en"
                              ? "col-form-label"
                              : "col-form-label fk"
                          }`}
                        >
                          {change_Lang("Lawyer's name")}:
                        </label>
                      </div>
                      <div className="col-sm-8 ">
                        <Input
                          className={`${
                            lang === "en"
                              ? "form-control text-center"
                              : "form-control text-center fk"
                          }`}
                          style={{
                            color: "black",
                          }}
                          value={lawman}
                          onChange={OnChangeHandler}
                          name="lawman"
                          type="text"
                          autoComplete="off"
                          addonBefore={
                            <>
                              <Popover
                                content={
                                  <div className="text-center">
                                    <span
                                      className="fk"
                                      style={{ fontSize: "14px" }}
                                    >
                                      پاش واژوکردن لەسەر ئەم گرێبەستە ئەگەر
                                      هاتوو مولکی فرۆشراو تاپۆی هەبوو پێویستە
                                      لەسەرلایەنی یەکەم کەوا بریکارنامە بدات بە
                                      پارێزەر ______
                                      <br />
                                      بەمەبەستی گواستنەوەی خاوەنداریەتی و
                                      تۆمارکردنی موڵکی فرۆشراو بۆ لایەنی دووەم
                                    </span>
                                    <br />
                                    <span className="text-center">
                                      نمونە : محمد عبداللە عمر
                                    </span>
                                  </div>
                                }
                              >
                                <FaInfoCircle
                                  style={{
                                    justifyContent: "center",
                                    alignItems: "center",
                                    display: "flex",
                                    color: "#000",
                                    fontWeight: "bolder",
                                  }}
                                  size={15}
                                />
                              </Popover>
                            </>
                          }
                        />
                      </div>
                    </div>
                    <div className="product-price digits mt-2 d-flex justify-content-start form-group row">
                      <div className="col-sm-4">
                        <label
                          style={{
                            fontSize: "14px",
                            color: "#052f43",
                            fontWeight: "bold",
                          }}
                          className={`d-flex justify-content-start ${
                            lang === "en"
                              ? "col-form-label"
                              : "col-form-label fk"
                          }`}
                        >
                          {change_Lang("Date of surrender")}:
                        </label>
                      </div>
                      <div className="col-sm-8 ">
                        <Input
                          className="form-control"
                          style={{
                            color: "black",
                          }}
                          value={duedate ? duedate : today}
                          onChange={OnChangeHandler}
                          name="duedate"
                          type="date"
                          addonBefore={
                            <>
                              <Popover
                                content={
                                  <div className="text-center">
                                    <span
                                      className="fk"
                                      style={{ fontSize: "14px" }}
                                    >
                                      {
                                        "لایەنی یەکەم پێوەستە ئەم موڵکە ڕادەستی لایەنی دووەم(کڕیار) بکات بەرواری ڕادەستکردن داخڵ بکە"
                                      }
                                    </span>
                                    <br />
                                    <span className="text-center">
                                      نمونە : مانگ/ڕۆژ/ساڵ
                                    </span>
                                  </div>
                                }
                              >
                                <FaInfoCircle
                                  style={{
                                    justifyContent: "center",
                                    alignItems: "center",
                                    display: "flex",
                                    color: "#000",
                                    fontWeight: "bolder",
                                  }}
                                  size={15}
                                />
                              </Popover>
                            </>
                          }
                        />
                      </div>
                    </div>
                    <div className="product-price digits mt-2 d-flex justify-content-start form-group row">
                      <div className="col-sm-4">
                        <label
                          style={{
                            fontSize: "16px",
                            color: "#052f43",
                            fontWeight: "bold",
                          }}
                          className={`d-flex justify-content-start ${
                            lang === "en"
                              ? "col-form-label"
                              : "col-form-label fk"
                          }`}
                        >
                          {change_Lang("type of contract")}:
                        </label>
                      </div>
                      <div
                        className={`${
                          lang === "en" ? "col-sm-8" : "col-sm-8 fk"
                        }`}
                      >
                        <Select
                          onChange={handleChange_Status}
                          value={status}
                          defaultValue={change_Lang("Choose")}
                          className="fk col-12 text-center"
                          showArrow={false}
                          size="large"
                          style={{
                            fontSize: "16px",
                            borderBottomColor: "#4064d7",
                          }}
                        >
                          <Option value="" className="fk">
                            {change_Lang("Choose")}
                          </Option>
                          <Option className="fk" value={"active"}>
                            {change_Lang("active")}
                          </Option>
                          <Option className="fk" value={"Rejected"}>
                            {change_Lang("Rejected")}
                          </Option>
                        </Select>
                      </div>
                    </div>
                    <div className="product-price digits mt-2 d-flex justify-content-start form-group row">
                      <div className="col-sm-4">
                        <label
                          style={{
                            fontSize: "18px",
                            fontWeight: "bolder",
                            color: "black",
                          }}
                          className={`d-flex justify-content-start ${
                            lang === "en"
                              ? "col-form-label"
                              : "col-form-label fk"
                          }`}
                        ></label>
                      </div>
                      <div className="col-sm-6 fk"></div>
                    </div>
                  </div>
                </div>
                <Divider className="fk" plain>
                  زیادکردنی خاڵ (کوردی)
                </Divider>
                <div className="row">
                  <div className="col-md-12">
                    {" "}
                    <Input
                      className="form-control"
                      onChange={OnChangeHandler}
                      type="text"
                      value={article_8}
                      name="article_8"
                      style={{
                        fontSize: "15px",

                        borderBottomColor: "#3889c1",
                      }}
                      addonBefore={
                        <>
                          <Popover
                            content={
                              <div className="text-center">
                                <span
                                  className="fk"
                                  style={{ fontSize: "14px" }}
                                >
                                  {"خاڵی 15"}
                                </span>
                                <br />
                                <span className="text-center"></span>
                              </div>
                            }
                          >
                            <span
                              style={{
                                justifyContent: "center",
                                alignItems: "center",
                                display: "flex",
                                color: "#000",
                                fontWeight: "bolder",
                              }}
                              size={15}
                            >
                              15
                            </span>
                          </Popover>
                        </>
                      }
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-12">
                    {" "}
                    <Input
                      className="form-control"
                      onChange={OnChangeHandler}
                      type="text"
                      value={article_9}
                      name="article_9"
                      style={{
                        fontSize: "15px",

                        borderBottomColor: "#3889c1",
                      }}
                      addonBefore={
                        <>
                          <Popover
                            content={
                              <div className="text-center">
                                <span
                                  className="fk"
                                  style={{ fontSize: "14px" }}
                                >
                                  {"خاڵی 16"}
                                </span>
                                <br />
                                <span className="text-center"></span>
                              </div>
                            }
                          >
                            <span
                              style={{
                                justifyContent: "center",
                                alignItems: "center",
                                display: "flex",
                                color: "#000",
                                fontWeight: "bolder",
                              }}
                              size={15}
                            >
                              16
                            </span>
                          </Popover>
                        </>
                      }
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-12">
                    {" "}
                    <Input
                      className="form-control"
                      onChange={OnChangeHandler}
                      type="text"
                      value={article_10}
                      name="article_10"
                      style={{
                        fontSize: "15px",

                        borderBottomColor: "#3889c1",
                      }}
                      addonBefore={
                        <>
                          <Popover
                            content={
                              <div className="text-center">
                                <span
                                  className="fk"
                                  style={{ fontSize: "14px" }}
                                >
                                  {"خاڵی 17"}
                                </span>
                                <br />
                                <span className="text-center"></span>
                              </div>
                            }
                          >
                            <span
                              style={{
                                justifyContent: "center",
                                alignItems: "center",
                                display: "flex",
                                color: "#000",
                                fontWeight: "bolder",
                              }}
                              size={15}
                            >
                              17
                            </span>
                          </Popover>
                        </>
                      }
                    />
                  </div>
                </div>
                <Divider className="fk" plain>
                  زیادکردنی خاڵ (عرەبی)
                </Divider>
                <div className="row">
                  <div className="col-md-12">
                    {" "}
                    <Input
                      className="form-control"
                      onChange={OnChangeHandler}
                      type="text"
                      value={article_8_ar}
                      name="article_8_ar"
                      style={{
                        fontSize: "15px",

                        borderBottomColor: "#3889c1",
                      }}
                      addonBefore={
                        <>
                          <Popover
                            content={
                              <div className="text-center">
                                <span
                                  className="fk"
                                  style={{ fontSize: "14px" }}
                                >
                                  {"خاڵی 14"}
                                </span>
                                <br />
                                <span className="text-center"></span>
                              </div>
                            }
                          >
                            <span
                              style={{
                                justifyContent: "center",
                                alignItems: "center",
                                display: "flex",
                                color: "#000",
                                fontWeight: "bolder",
                              }}
                              size={15}
                            >
                              14
                            </span>
                          </Popover>
                        </>
                      }
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-12">
                    {" "}
                    <Input
                      className="form-control"
                      onChange={OnChangeHandler}
                      type="text"
                      value={article_9_ar}
                      name="article_9_ar"
                      style={{
                        fontSize: "15px",

                        borderBottomColor: "#3889c1",
                      }}
                      addonBefore={
                        <>
                          <Popover
                            content={
                              <div className="text-center">
                                <span
                                  className="fk"
                                  style={{ fontSize: "14px" }}
                                >
                                  {"خاڵی 15"}
                                </span>
                                <br />
                                <span className="text-center"></span>
                              </div>
                            }
                          >
                            <span
                              style={{
                                justifyContent: "center",
                                alignItems: "center",
                                display: "flex",
                                color: "#000",
                                fontWeight: "bolder",
                              }}
                              size={15}
                            >
                              15
                            </span>
                          </Popover>
                        </>
                      }
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-12">
                    {" "}
                    <Input
                      className="form-control"
                      onChange={OnChangeHandler}
                      type="text"
                      value={article_10_ar}
                      name="article_10_ar"
                      style={{
                        fontSize: "15px",

                        borderBottomColor: "#3889c1",
                      }}
                      addonBefore={
                        <>
                          <Popover
                            content={
                              <div className="text-center">
                                <span
                                  className="fk"
                                  style={{ fontSize: "14px" }}
                                >
                                  {"خاڵی 16"}
                                </span>
                                <br />
                                <span className="text-center"></span>
                              </div>
                            }
                          >
                            <span
                              style={{
                                justifyContent: "center",
                                alignItems: "center",
                                display: "flex",
                                color: "#000",
                                fontWeight: "bolder",
                              }}
                              size={15}
                            >
                              16
                            </span>
                          </Popover>
                        </>
                      }
                    />
                  </div>
                </div>
                <br />
                {user && user.c_contract !== false ? (
                  <div className="row">
                    <div className="col-lg-3"></div>
                    <div className="col-12 col-lg-6">
                      <button
                        className="btn"
                        style={{ background: "#4350d8" }}
                        onClick={() => {
                          this.onCreating_SellContract();
                        }}
                      >
                        <span
                          className="d-none d-lg-inline"
                          style={{ color: "white", fontSize: "12px" }}
                        >
                          {change_Lang("save")} &nbsp;&nbsp;&nbsp;
                        </span>
                        <i
                          className="far fa-save"
                          style={{ fontSize: "18px", color: "white" }}
                        ></i>
                      </button>
                      <button
                        className="btn mx-5"
                        style={{ background: "#7F8C8D" }}
                        onClick={New_Page}
                      >
                        <span
                          className="d-none d-lg-inline"
                          style={{ color: "white", fontSize: "12px" }}
                        >
                          {" "}
                          {change_Lang("new_page")}&nbsp;&nbsp;&nbsp;
                        </span>
                        <i
                          className="fas fa-file"
                          style={{ fontSize: "18px", color: "white" }}
                        ></i>
                      </button>
                    </div>
                    <div className="col-lg-3"></div>
                  </div>
                ) : (
                  ""
                )}
              </div>
            </div>
          </div>
        </Fragment>
      );
    }
  }
}

const mapStateToProps = (state) => {
  return {
    lang: state.HelperReducer.lang,
    user: state.AuthReducer.user,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    change_Lang: (key) => dispatch(change_Lang(key)),
    EveryTimeTo_English: (keys) => dispatch(EveryTimeTo_English(keys)),
    Create_Sell_MainForm: (data) => dispatch(Create_Sell_MainForm(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SellSecondaryForm);
